import styled from 'styled-components';

import { theme } from '../../common/ui/theme';

export const ResultingDemandRow = styled.div<{ $showChanges: boolean }>`
    display: grid;
    grid-template-columns: minmax(0, 1fr) repeat(${({ $showChanges }) => ($showChanges ? 3 : 1)}, 120px);
    align-items: start;
    gap: ${theme.space[8]};
    padding: ${theme.space[8]};
    text-align: right;

    > :first-child {
        min-width: 0;
        text-align: left;
    }

    > :last-child {
        padding-right: ${theme.space[8]};
    }
`;
